import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ReportTemplateViewModel } from "../system/admin-panel/Reports/Models/ReportTemplateViewModel";
import { Observable } from "rxjs";
import { ReportColumnModel } from "../system/admin-panel/Reports/Models/ReportColumnModel";
import {KeyViewModel} from "../system/admin-panel/Keys/Model/KeyViewModel";

@Injectable()
export class ReportTemplateService {
  constructor(private client: HttpClient) {
  }

  public getReportTemplates(): Observable<ReportTemplateViewModel[]> {
    return this.client.get<any>("/ctrl/reporttemplates").pipe(map(values => {
      let result: ReportTemplateViewModel[] = [];

      for (let item of values)
        result.push(ReportTemplateViewModel.fromJS(item));

      return result;
    }));
  }
  public getReport(id: number) {
    return this.client.get<any>("/ctrl/ReportTemplates/" + id).pipe(map(value => {
      return ReportTemplateViewModel.fromJS(value);
    }))
  }

  public update(model: ReportTemplateViewModel) {
    return this.client.put("/ctrl/reporttemplates", model);
  }

  public create(model: ReportTemplateViewModel): Observable<ReportTemplateViewModel> {
    return this.client.post<ReportTemplateViewModel>("/ctrl/reporttemplates", model).pipe(
      map(report => ReportTemplateViewModel.fromJS(report))
    );
  }

  public delete(id: number) {
    return this.client.delete("/ctrl/reporttemplates/"+id);
  }

  public getReportTypes(): Observable<Map<number, string>> {
    return this.client.get<any>("/ctrl/reporttemplates/GetReportTypes").pipe(map(values => {
      let res = new Map<number, string>();
      for (var i in values)
        res.set(parseInt(i), values[i]);
      return res;
    }));
  }
  public getReportColumnTypes(reportType: number): Observable<ReportColumnModel[]> {
    return this.client.get<any>("/ctrl/reporttemplates/GetReportColumns/" + reportType).pipe(map(values => {
      let res: ReportColumnModel[] = [];
      for (let item of values)
        res.push(ReportColumnModel.fromJS(item));
      return res;
    }));
  }
}
